import { render, staticRenderFns } from "./CrazyGamesSignInButton.vue?vue&type=template&id=71e07d8c&"
import script from "./CrazyGamesSignInButton.vue?vue&type=script&lang=ts&"
export * from "./CrazyGamesSignInButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports